import { BaseText, ListItem, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { VEHICLE_INPUT_ICON_SIZE } from './VehicleIcons';

const LowEmissionIconWrapper = styled.View`
  margin-left: 20px;
`;

const LowEmissionIcon = () => (
  <LowEmissionIconWrapper>
    <Icon
      name="leaf"
      size={VEHICLE_INPUT_ICON_SIZE}
      color={theme.colors.white}
    />
  </LowEmissionIconWrapper>
);

const VehicleLowEmissionInfo = () => {
  const { t } = useTranslation();

  const Title = () => <BaseText>{t('vehicle.lowEmission.title')}</BaseText>;
  return (
    <ListItem
      testID="edit-vehicle-low-emission"
      onPress={undefined}
      withBorderRadius={true}
      borderColor={theme.colors.gray100}
      item={null}
      titleComponent={Title}
      indexValue={0}
      iconComponent={LowEmissionIcon}
    />
  );
};

export default VehicleLowEmissionInfo;
